import { Alert, AlertTitle, Slide, Snackbar } from "@mui/material";
import { updateAlert, useGlobalState, GlobalAlert } from "~/lib/globalAlerts";

export default function GlobalAlerts(): React.ReactElement {
  const [alerts] = useGlobalState("alerts");

  const handleClose = (alert: GlobalAlert) => {
    console.log("close alert", alert);
    updateAlert(alert.id, { ...alert, closed: true });
  };

  return (
    <>
      {Object.values(alerts).map((alert) => (
        <Snackbar
          sx={{ mt: 8 }}
          open={alert.closed === false}
          key={alert.id}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Alert onClose={() => handleClose(alert)} severity={alert.severity}>
            {alert.title && <AlertTitle>{alert.title}</AlertTitle>}
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
